import Slider from '../slider/slider';

export default (element) => {
  const init = () => {
    const el = element.querySelector('[data-multi-column-slider]');

    let slider = new Slider({
      el,
      options: {
        slidesPerView: 1.2,
        spaceBetween: 15,
        centeredSlides: true,
        breakpoints: {
          960: {
            slidesPerView: el.dataset.columns,
            spaceBetween: 20,
            centeredSlides: false,
          },
        },
        autoplay: false,
      },
    });
  };

  init();
};
